var React = require('react');

function SearchBlue (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;fill-rule:evenodd;}")),React.createElement("path",{"id":"Search","fill":"#0DB0E7","d":"M26,24.77l-7.69-7.63a10.43,10.43,0,1,0-1.23,1.22L24.77,26Zm-15.6-5.7a8.67,8.67,0,1,1,8.67-8.67A8.67,8.67,0,0,1,10.4,19.07Z","key":1})]);
}

SearchBlue.defaultProps = {"width":"28px","height":"28px","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 26 26"};

module.exports = SearchBlue;

SearchBlue.default = SearchBlue;
